export default __webpack_public_path__ + "static/banner_ghca-01dd089bc8b22692f0f814302b61924d.jpg";